/**
 *   - populate some empty span in the website
 *   - open the toolbar/scheme
 */
 import functions from './functions'

 var pageconfig = JSON.parse($('#pageconfig').val())

const initGui = () => {

  /**
  * init tooltip
  */

   $('[data-toggle="tooltip"]').tooltip()

  /**
   * open the tools menu container on load by default
   * based on the value of the variable
   * apply just from tablet onward
   */

  if (pageconfig.tools) {
    if (!functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  }

  /**
   * open the scheme list on load
   * based on the value of the variable
   * apply just from tablet onward
   * we check also if the tools is open because if the tools is closed there is no point to schow the scheme list
   * !! EVENTUALLY WE CAN CREATE A FUNCTION AND REUSE IT TO OPEN OTHER TABS
   */

  if (pageconfig.tools && pageconfig.tabopen) {
    if (!functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
      if (pageconfig.appname.type === 'consult') {
            $('#headingFive button').click()
      } else if (pageconfig.appname.type === 'accsmap') {
            $('#headingThree button').click()
      } else {
            $('#headingOne button').click()
      }
    }
  }

  /**
   * populate some sections based on config
   */

  $('.copyyear').text(new Date().getFullYear())
  $('.website').prop('href', pageconfig.website)

  if (pageconfig.appname.type === 'accsmap') {
    $('.pdate').text(functions.getPublishDate('accsmap').split('-').reverse().join('/'))
  }

}

/**
 * EXPORT
 */

export default {
  initGui
}
